export default {"src":"/_next/static/media/SU.812cbdda.svg","height":18,"width":18};